import React, { useState } from 'react';
import { EmailClient } from "@azure/communication-email";
import { CosmosClient } from "@azure/cosmos";
import { cosmosDBpost } from './service/app.js';

const connectionString = "endpoint=https://emailsvc.unitedstates.communication.azure.com/;accesskey=7oaDOJh3dzL1x3TjCpGdXWvvHHrQEJRkXT45cyqOJNCw7dL7k9VlJQQJ99BBACULyCpST4kgAAAAAZCSwjvy";
const client = new EmailClient(connectionString);


async function alertBob(driverName, email, mobile, captcha) {
    var currentdate = new Date();
    const emailMessage = {
        senderAddress: "DoNotReply@116db5fa-431b-46ab-a2bc-e06d5578d1ef.azurecomm.net",
        content: {
            subject: "MCC Sign Up Alert",
            plainText: "New MCC sign-up: " + driverName + " ; " + email + " ; " + mobile + " ; on: " + currentdate + "."
            /* plainText: "New MCC sign-up: " + currentdate + "." */
        },
        recipients: {
            to: [{ address: "bobtrieste@gmail.com" }],
        },

    }
    const poller = await client.beginSend(emailMessage);
    const result = await poller.pollUntilDone();

}

async function alertRecip(driverName, email) {
    const emailMessage = {
        senderAddress: "DoNotReply@116db5fa-431b-46ab-a2bc-e06d5578d1ef.azurecomm.net",
        content: {
            subject: "Registration successful. Thank you.",
            plainText: "Welcome " + driverName +
                ", Thank you for registering with Manhasset Cars and Coffee! \n\nWe meet informally every weather - permitting Sunday at Macy's in Manhasset from roughly 8am to 11am - See you there!!" + "\n\nIn the meantime, enjoy some of these links below." +
                "\n\nPhoto Gallery:" +
                "\nhttps://bobtrieste.smugmug.com/Cars/Summer2020" +
                "\n\nVideos:" +
                "\nhttps://vimeo.com/showcase/5083448" +
                "\n\nInstagram:" +
                "\nhttps://www.instagram.com/manhassetcarsandcoffee" +
                "\n\nWeb:" +
                "\nhttp://manhassetcarsandcoffee.com" +
                "\n\n\nBob Trieste" +
                "\n917-806-6333" +
                "\nbobtrieste@gmail.com"
        },
        recipients: {
            to: [{ address: email }],
        },
    }
    const poller = await client.beginSend(emailMessage);
    const result = await poller.pollUntilDone();
}


function ContactForm() {
    const [driverName, setdriverName] = useState('');
    const [email, setEmail] = useState('');
    const [mobile, setMobile] = useState('');
    const [captcha, setCaptcha] = useState('');
    const [isSuccess, setIsSuccess] = useState(false);
    const [isError, setIsError] = useState(false);


    const handleSubmit = (event) => {
        event.preventDefault();

        if (driverName !== '' && email !== '' && mobile !== '' && captcha === '911') {
            cosmosDBpost(driverName, email, mobile);
            alertBob(driverName, email, mobile, captcha);
            alertRecip(driverName, email);
            setdriverName('');
            setEmail('');
            setMobile('');
            setCaptcha('');
            setIsSuccess(true);
            setTimeout(() => {
                setIsSuccess(false);
            }, 6000);
        } else {
            setIsError(true);
            setTimeout(() => {
                setIsError(false);
            }, 5000);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <div>
                <p style={{ textAlign: 'left', fontSize: '30px', color: 'yellow' }}>
                    <label htmlFor="driverName">Name:</label><br />
                    <input
                        type="text"
                        id="driverName"
                        value={driverName}
                        onChange={(e) => setdriverName(e.target.value)}
                        required
                    /></p>
            </div>
            <div>
                <p style={{ textAlign: 'left', fontSize: '30px', color: 'yellow' }}>
                    <label htmlFor="email">Email:</label><br />
                    <input
                        type="email"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    /></p>
            </div>
            <div>
                <p style={{ textAlign: 'left', fontSize: '30px', color: 'yellow' }}>
                    <label htmlFor="mobile">Mobile (no dashes):</label><br />
                    <input
                        id="mobile"
                        value={mobile}
                        onChange={(e) => setMobile(e.target.value)}
                        required
                    /></p>
            </div>
            <div>
                <p style={{ textAlign: 'left', fontSize: '30px', color: 'yellow', whiteSpace: 'pre-line' }}>
                    <label htmlFor="captcha">Numbers below (prove not a robot):</label><br />
                    <input
                        id="captcha"
                        value={captcha}
                        onChange={(e) => setCaptcha(e.target.value)}
                        required
                    /></p>
            </div>
            <p style={{ textAlign: 'left', fontSize: '32px' }}> <img src="reCaptcha.jpg" alt="reCaptcha" /></p>
            <button type="submit" style={{ fontSize: '1.2rem', padding: '10px 20px' }} >Sign-up</button>

            {isSuccess && <div style={{ color: 'white', background: 'green', padding: '5px' }}>Form submited successfully. Thank you, please check spam folder for welcome e-mail.</div>}
            {isError && <div style={{ color: 'white', background: 'orange', padding: '5px' }}>Please fix any errors and fill in all boxes.</div>}

        </form>
    );
}

export default ContactForm;
